import { render, staticRenderFns } from "./ResumeHighlights.vue?vue&type=template&id=31edeb36"
import script from "./ResumeHighlights.vue?vue&type=script&lang=js"
export * from "./ResumeHighlights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports